import { getBlockName } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import { getCriteriaLimitedBlockIds, getCriterionLabel } from '../useBlockVisibility/helpers'

const getCriterionBlockIds = ({ criterion, criteriaLimitedBlockIds, getBlockVisibility }) => {
  return criteriaLimitedBlockIds.filter(blockId => {
    return getBlockVisibility(blockId).visibility_criterion_ids.includes(criterion.id)
  })
}

const getCriterionBlocks = ({ criterionBlockIds, blockSettings, t }) => {
  return criterionBlockIds.map(blockId => ({ blockId, name: getBlockName(blockId, blockSettings, t) }))
}

const buildScenarioCriterion = ({
  criterion,
  criteriaLimitedBlockIds,
  getBlockVisibility,
  disabledCriterionIds,
  blockSettings,
  t,
}) => {
  const criterionBlockIds = getCriterionBlockIds({ criterion, criteriaLimitedBlockIds, getBlockVisibility })

  return {
    id: criterion.id,
    label: getCriterionLabel(criterion),
    isActive: !disabledCriterionIds.includes(criterion.id),
    blocks: getCriterionBlocks({ criterionBlockIds, blockSettings, t }),
  }
}

const hasCriterionBlocks = criterion => criterion.blocks.length > 0

export const getScenarioCriteria = ({
  layout,
  getBlockVisibility,
  criteriaOptions,
  disabledCriterionIds,
  blockSettings,
  t,
}) => {
  if (!layout) return []

  const criteriaLimitedBlockIds = getCriteriaLimitedBlockIds(layout, getBlockVisibility)

  const scenarioCriteria = criteriaOptions.map(criterion => {
    return buildScenarioCriterion({
      criterion,
      criteriaLimitedBlockIds,
      getBlockVisibility,
      disabledCriterionIds,
      blockSettings,
      t,
    })
  })

  return scenarioCriteria.filter(hasCriterionBlocks)
}
